import PropTypes from 'prop-types';
import { mapConstants } from '@gisatcz/ptr-core';
import { Icon, Button } from '@gisatcz/ptr-atoms';
import { map as mapUtils } from '@gisatcz/ptr-utils';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MapControls = function MapControls(_ref) {
  var view = _ref.view,
    viewLimits = _ref.viewLimits,
    updateView = _ref.updateView,
    resetHeading = _ref.resetHeading,
    mapKey = _ref.mapKey,
    zoomOnly = _ref.zoomOnly,
    levelsBased = _ref.levelsBased,
    mapHeight = _ref.mapHeight,
    mapWidth = _ref.mapWidth;
  var tiltIncrement = 5;
  var headingIncrement = 1.0;
  var zoomIncrement = 0.04;
  var resetHeadingDisabled = !(view !== null && view !== void 0 && view.heading) || (view === null || view === void 0 ? void 0 : view.heading) === 360;
  var handleTiltUp = function handleTiltUp() {
    var update = {
      tilt: view.tilt - tiltIncrement
    };
    updateView(update, mapKey);
  };
  var handleTiltDown = function handleTiltDown() {
    var update = {
      tilt: view.tilt + tiltIncrement
    };
    updateView(update, mapKey);
  };
  var handleHeadingRight = function handleHeadingRight() {
    var update = {
      heading: view.heading - headingIncrement
    };
    updateView(update, mapKey);
  };
  var handleHeadingLeft = function handleHeadingLeft() {
    var update = {
      heading: view.heading + headingIncrement
    };
    updateView(update, mapKey);
  };
  var handleZoomIn = function handleZoomIn() {
    var update = null;
    if (levelsBased && view && view.boxRange) {
      // remove 1 from box range to prevent rounding issues
      update = {
        boxRange: (view.boxRange - 1) / 2
      };
    } else {
      update = {
        boxRange: view.boxRange * (1 - zoomIncrement)
      };
    }
    updateView(update, mapKey);
  };
  var handleZoomOut = function handleZoomOut() {
    var update;
    if (levelsBased && view && view.boxRange) {
      // add 1 to box range to prevent rounding issues
      update = {
        boxRange: view.boxRange * 2 + 1
      };
    } else {
      update = {
        boxRange: view.boxRange * (1 + zoomIncrement)
      };
    }
    updateView(update, mapKey);
  };
  var handleResetHeading = function handleResetHeading() {
    resetHeading(mapKey);
  };
  var isZoomButtonActive = function isZoomButtonActive(type) {
    var definedLimits = viewLimits === null || viewLimits === void 0 ? void 0 : viewLimits.boxRangeRange;
    var currentBoxRange = view === null || view === void 0 ? void 0 : view.boxRange;
    if (levelsBased) {
      var currentLevel = mapUtils.view.getZoomLevelFromBoxRange(currentBoxRange, mapWidth, mapHeight);
      if (type === 'in') {
        var maxZoom = mapConstants.defaultLevelsRange[1];
        if (definedLimits && definedLimits[0]) {
          var definedLimitAsLevel = mapUtils.view.getZoomLevelFromBoxRange(definedLimits[0], mapWidth, mapHeight);
          if (definedLimitAsLevel < maxZoom) {
            maxZoom = definedLimitAsLevel;
          }
        }
        return currentLevel < maxZoom;
      } else {
        var minZoom = mapConstants.defaultLevelsRange[0];
        if (definedLimits && definedLimits[1]) {
          var _definedLimitAsLevel = mapUtils.view.getZoomLevelFromBoxRange(definedLimits[1], mapWidth, mapHeight);
          if (_definedLimitAsLevel > minZoom) {
            minZoom = _definedLimitAsLevel;
          }
        }
        return currentLevel > minZoom;
      }
    } else {
      if (type === 'in') {
        var limit = definedLimits && definedLimits[0] || mapConstants.minBoxRange;
        return currentBoxRange * (1 - zoomIncrement) >= limit;
      } else {
        var _limit = definedLimits && definedLimits[1] || mapConstants.maxBoxRange;
        return currentBoxRange * (1 + zoomIncrement) <= _limit;
      }
    }
  };

  // TODO different controls for 2D
  return /*#__PURE__*/_jsxs("div", {
    className: "ptr-map-controls",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "zoom-control control",
      children: [/*#__PURE__*/_jsx(Button, {
        onHold: function onHold() {
          handleZoomIn();
        },
        onClick: function onClick() {
          handleZoomIn();
        },
        disabled: !isZoomButtonActive('in'),
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "plus-thick"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onHold: function onHold() {
          handleZoomOut();
        },
        onClick: function onClick() {
          handleZoomOut();
        },
        disabled: !isZoomButtonActive('out'),
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "minus-thick"
        })
      })]
    }), !zoomOnly ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "rotate-control control",
        children: [/*#__PURE__*/_jsx(Button, {
          onHold: function onHold() {
            handleHeadingRight();
          },
          onClick: function onClick() {
            handleHeadingRight();
          },
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "rotate-right"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            handleResetHeading();
          },
          disabled: resetHeadingDisabled,
          children: /*#__PURE__*/_jsx(Icon, {
            style: {
              transform: "rotate(".concat(view ? -view.heading : 0, "deg)")
            },
            icon: "north-arrow"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onHold: function onHold() {
            handleHeadingLeft();
          },
          onClick: function onClick() {
            handleHeadingLeft();
          },
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "rotate-left"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "tilt-control control",
        children: [/*#__PURE__*/_jsx(Button, {
          className: "tilt-more-control",
          onHold: function onHold() {
            handleTiltDown();
          },
          onClick: function onClick() {
            handleTiltDown();
          },
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "tilt-more"
          })
        }), /*#__PURE__*/_jsx(Button, {
          className: "tilt-more-control",
          onHold: function onHold() {
            handleTiltUp();
          },
          onClick: function onClick() {
            handleTiltUp();
          },
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "tilt-less"
          })
        })]
      })]
    }) : null]
  });
};
MapControls.propTypes = {
  heading: PropTypes.number,
  view: PropTypes.object,
  viewLimits: PropTypes.object,
  updateView: PropTypes.func,
  resetHeading: PropTypes.func,
  mapKey: PropTypes.string,
  zoomOnly: PropTypes.bool,
  levelsBased: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  mapHeight: PropTypes.number,
  mapWidth: PropTypes.number
};
export default MapControls;